import { Box, CircularProgress, TextField } from "@mui/material";
import AuthPageLayout from "../../components/auth/AuthPageLayout";
import LoginSideImage from '../../images/login/login-side-teacher.png';
import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import Fetch from "../../services/Fetch";
import SnackbarAlert from "../../components/SnackBar";
import AuthContext from "../../context/AuthContext";
import useSnackBar from "../../hooks/UseSnackBar";
import { useWaits } from "../../hooks/UseWait";
import { buildLoginFormData } from "../../helper/LoginFormData";
import { useConstants } from "../../hooks/UseConstants";

const loginInputSx = {
    width: '100%',
    '& .MuiInputLabel-root': { color: 'rgba(255,255,255,0.85)' },
    '& .MuiInputLabel-root.Mui-focused': { color: '#fff' },
    '& .MuiInput-underline:before': { borderBottomColor: 'rgba(255,255,255,0.5)' },
    '& .MuiInput-underline:hover:not(.Mui-disabled):before': { borderBottomColor: '#fff' },
    '& .MuiInput-underline:after': { borderBottomColor: '#fff' },
    '& .MuiInputBase-input': { color: '#fff' },
};

function Login() {
     const { host, language } = useConstants();
     const isAr = language === "ar";
     const { wait } = useContext(AuthContext);
     const { openSnackBar, type, message, setSnackBar, setOpenSnackBar } = useSnackBar();
     const { sendWait, setSendWait } = useWaits();
     const [email, setEmail] = useState('');
     const [password, setPassword] = useState('');
     const navigate = useNavigate();

     const login = async () => {
          if (!email.trim() || !password) {
               setSnackBar("error", isAr ? "أدخل البريد الإلكتروني وكلمة المرور" : "Enter your email and password");
               return;
          }

          setSendWait(true);

          const formData = buildLoginFormData({
               email: email.trim(),
               password,
          });
          const result = await Fetch(`${host}/login`, "POST", formData);

          if (result.status === 200) {
               localStorage.setItem('token', result.data.data.token);
               localStorage.setItem('language', result.data.data.user?.language || language || 'ar');
               localStorage.setItem('id', result.data.data.user.id);
               navigate('/dashboard');
          } else if (result.status === 422 || result.status === 400) {
               setSnackBar("error", result.data?.errors?.[0] || result.data?.message);
          } else {
               setSnackBar("error", isAr ? "تعذر تسجيل الدخول" : "Unable to sign in");
          }
          setSendWait(false);
     };

     return (
          <>
               {wait ? (
                    <Box className="w-full h-screen relative flex justify-center items-center">
                         <CircularProgress size={70} />
                    </Box>
               ) : (
                    <AuthPageLayout
                         sideImage={LoginSideImage}
                         sideTitle={isAr ? 'شارك معرفتك مع آلاف الطلاب' : 'Share your knowledge with thousands of students'}
                         sideSubtitle={isAr ? 'أدر دوراتك ومساراتك وأرباحك من لوحة مدرس احترافية وسهلة الاستخدام.' : 'Manage your courses, paths, and earnings from a professional teacher dashboard.'}
                         badge={isAr ? "لوحة المعلم" : "Teacher dashboard"}
                         title={isAr ? "تسجيل الدخول" : "Sign In"}
                         footer={(
                              <>
                                   <Box onClick={() => navigate('/forgot-password')} className="cursor-pointer hover:underline">
                                        {isAr ? "نسيت كلمة المرور؟" : "Forgot password?"}
                                   </Box>
                                   <Box onClick={() => navigate('/register')} className="cursor-pointer hover:underline text-end">
                                        {isAr ? "إنشاء حساب جديد" : "Create account"}
                                   </Box>
                              </>
                         )}
                    >
                         <TextField
                              value={email}
                              onChange={(e) => setEmail(e.target.value)}
                              label={isAr ? "البريد الإلكتروني" : "Email"}
                              type="email"
                              variant="standard"
                              sx={loginInputSx}
                              slotProps={{ htmlInput: { className: 'py-5' } }}
                         />
                         <TextField
                              value={password}
                              onChange={(e) => setPassword(e.target.value)}
                              type="password"
                              label={isAr ? "كلمة المرور" : "Password"}
                              variant="standard"
                              sx={loginInputSx}
                         />
                         <button type="button" onClick={login} disabled={sendWait} className="auth-btn-primary disabled:opacity-70">
                              {sendWait ? <CircularProgress size={20} color="inherit" /> : (isAr ? "دخول" : "Sign in")}
                         </button>
                    </AuthPageLayout>
               )}
               <SnackbarAlert open={openSnackBar} message={message} severity={type} onClose={() => setOpenSnackBar(false)} />
          </>
     );
}

export default Login;
